import React, { useState } from 'react';
import { ArrowLeft, User, Plus, CheckCircle2 } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const PersonalInfoEditScreen = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    firstName: 'Florin',
    lastName: 'Blondu',
    phone: '+40720108964',
    email: 'blonduflorin8@gmail.com'
  });

  const handleBack = () => {
    navigate(-1);
  };

  const handleSave = () => {
    // Handle save logic here
    navigate(-1);
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <div className="px-4 py-4 border-b border-gray-200 flex items-center">
        <button onClick={handleBack} className="mr-4">
          <ArrowLeft className="w-6 h-6 text-gray-800" />
        </button>
        <h1 className="text-2xl font-semibold">Informații personale</h1>
      </div>

      <div className="p-4">
        {/* Avatar Section */}
        <div className="mb-8 flex flex-col items-center">
          <div className="w-24 h-24 bg-gray-100 rounded-full relative flex items-center justify-center mb-2">
            <User className="w-12 h-12 text-gray-400" />
            <button className="absolute bottom-0 right-0 w-8 h-8 bg-blue-600 rounded-full flex items-center justify-center border-4 border-white">
              <Plus className="w-5 h-5 text-white" />
            </button>
          </div>
          <p className="text-center text-gray-500 text-sm">
            Adaugă o poză de profil pentru ca șoferii să te recunoască
          </p>
          <button className="mt-2 text-blue-600 text-sm font-medium">
            Când îmi vede șoferul poza?
          </button>
        </div>

        {/* Form Fields */}
        <div className="space-y-6">
          {/* Name Field */}
          <div>
            <label className="block text-sm text-gray-500 mb-2">
              Te rugăm să-ți introduci numele așa cum apare pe actul tău de identitate sau în pașaport.
            </label>
            <div className="space-y-4">
              <input
                type="text"
                placeholder="Prenume"
                value={formData.firstName}
                onChange={(e) => setFormData({...formData, firstName: e.target.value})}
                className="w-full p-4 bg-gray-50 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
              <input
                type="text"
                placeholder="Nume de familie"
                value={formData.lastName}
                onChange={(e) => setFormData({...formData, lastName: e.target.value})}
                className="w-full p-4 bg-gray-50 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
          </div>

          {/* Phone Field */}
          <div>
            <div className="flex items-center mb-2">
              <p className="text-gray-500 text-sm flex-1">Număr de telefon</p>
              <CheckCircle2 className="w-5 h-5 text-blue-600" />
            </div>
            <div className="flex items-center bg-gray-50 rounded-lg px-4">
              <span className="text-gray-500">+40</span>
              <input
                type="tel"
                value={formData.phone.replace('+40', '')}
                onChange={(e) => setFormData({...formData, phone: '+40' + e.target.value})}
                className="flex-1 p-4 bg-transparent focus:outline-none"
              />
            </div>
          </div>

          {/* Email Field */}
          <div>
            <div className="flex items-center mb-2">
              <p className="text-gray-500 text-sm flex-1">Adresa de e-mail</p>
              <CheckCircle2 className="w-5 h-5 text-blue-600" />
            </div>
            <input
              type="email"
              value={formData.email}
              onChange={(e) => setFormData({...formData, email: e.target.value})}
              className="w-full p-4 bg-gray-50 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
        </div>

        {/* Save Button */}
        <div className="fixed bottom-8 left-4 right-4">
          <button
            onClick={handleSave}
            className="w-full bg-blue-600 text-white py-4 rounded-lg font-medium hover:bg-blue-700 transition-colors"
          >
            Salvează
          </button>
        </div>
      </div>
    </div>
  );
};

export default PersonalInfoEditScreen;